///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import IReportVisitNoteType = Meevo.Plugins.Reports.IReportVisitNoteType;

    export class ReportVisitNoteTypeCollection extends SmartMoverApiCollection<IReportVisitNoteType> implements IApiCollection<IReportVisitNoteType> {

        protected get url() {
            return this.options.url || 'VisitNoteType';
        }

        constructor(connectedModel: ModelValueType[], items: IReportVisitNoteType[] = [], options: ICollectionOptions<IReportVisitNoteType> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                'businessTypeList': null,
                'locationList': null,
                'hierarchyId': null,
                'branchId': null,
                'objectStateEnumList': [ObjectStateEnum.Active],
                'displayName': null,
                'fieldOrderBy': 'DisplayName',
                'orderAscDesc': 'Ascending',
                'IncludeInactive': true,
                'IncludeActive': true,
                'excludePrivateTypes':true
            });
        }

        public resetCollection(data: ModelValueType[]): void {
            this.connectedModel.length = 0;
            this.connectedModel.push(...data);

            if (this.options.smartMoverHidden()) {
                this.connectedModel.length = 0;
            }
        }
    }

}
